import { useMemo, useState } from 'react'
import { CloserToolbarSelect } from '@/components/CloserLeads/CloserToolbarSelect'
import { GestorJornadaFiltersPanel } from '@/components/Gestores/GestorJornadaFiltersPanel'
import { GestorTabFiltersBar } from '@/components/Gestores/GestorTabFiltersBar'
import { GestorTabFiltersPopover } from '@/components/Gestores/GestorTabFiltersPopover'
import {
  JORNADA_SITUACAO_FILTERS,
  buildJornadaSituacaoCounts,
  type JornadaSituacaoFilter,
  type JornadaViewMode,
} from '@/components/Gestores/gestorJornadaFilters'
import type { GestorJornadaMembro } from '@/services/gestoresService'

type Props = {
  membros: GestorJornadaMembro[]
  search: string
  setSearch: (v: string) => void
  situacao: JornadaSituacaoFilter
  setSituacao: (v: JornadaSituacaoFilter) => void
  view: JornadaViewMode
  setView: (v: JornadaViewMode) => void
}

export function GestorJornadaFilters({
  membros,
  search,
  setSearch,
  situacao,
  setSituacao,
  view,
  setView,
}: Props) {
  const [filtersOpen, setFiltersOpen] = useState(false)
  const counts = useMemo(() => buildJornadaSituacaoCounts(membros), [membros])

  const situacaoOptions = useMemo(
    () =>
      JORNADA_SITUACAO_FILTERS.map((f) => ({
        value: f.id,
        label:
          f.id === 'todas'
            ? `Todas as situações (${counts.todas})`
            : `${f.label} (${counts[f.id]})`,
      })),
    [counts],
  )

  const advancedFilterCount = view !== 'lista' ? 1 : 0
  const hasActiveFilter = search.trim().length > 0 || situacao !== 'todas' || view !== 'lista'

  const clearAllFilters = () => {
    setSearch('')
    setSituacao('todas')
    setView('lista')
    setFiltersOpen(false)
  }

  return (
    <GestorTabFiltersBar
      search={search}
      onSearchChange={setSearch}
      searchPlaceholder='Buscar profissional por nome ou setor…'
      searchAriaLabel='Buscar na jornada'
      showClear={hasActiveFilter}
      onClearAll={clearAllFilters}
    >
      <CloserToolbarSelect
        value={situacao}
        onChange={(v) => setSituacao(v as JornadaSituacaoFilter)}
        options={situacaoOptions}
        aria-label='Filtrar por situação da 1:1'
      />

      <GestorTabFiltersPopover
        open={filtersOpen}
        onToggle={() => setFiltersOpen((open) => !open)}
        onClose={() => setFiltersOpen(false)}
        advancedFilterCount={advancedFilterCount}
        panel={
          <GestorJornadaFiltersPanel
            open={filtersOpen}
            onClose={() => setFiltersOpen(false)}
            onClearAll={clearAllFilters}
            view={view}
            setView={setView}
          />
        }
      />
    </GestorTabFiltersBar>
  )
}
